/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingScanSectionDto } from './buildingScanSectionDto';
import { BuildingScanBuildingDto } from './buildingScanBuildingDto';


export interface BuildingScanItemDto { 
    id: string;
    name: string;
    building: BuildingScanBuildingDto;
    fileSize: number;
    createdAt: string;
    type: BuildingScanItemDto.TypeEnum;
    pointCloudId?: string;
    sections: Array<BuildingScanSectionDto>;
}
export namespace BuildingScanItemDto {
    export type TypeEnum = 'Panorama' | 'PointCloud';
    export const TypeEnum = {
        Panorama: 'Panorama' as TypeEnum,
        PointCloud: 'PointCloud' as TypeEnum
    };
}


